// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function empty(param) {
  return {
          id: undefined,
          name: "",
          domainType: "Subdomain",
          verificationStatus: "NotApplicable",
          active: true,
          deleted: false,
          defaultDomain: false,
          surveyFeedbackDomain: false,
          internalCommunicationDomain: false,
          systemGenerated: false
        };
}

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function domainType(t) {
  return t.domainType;
}

function verificationStatus(t) {
  return t.verificationStatus;
}

function active(t) {
  return t.active;
}

function deleted(t) {
  return t.deleted;
}

function defaultDomain(t) {
  return t.defaultDomain;
}

function surveyFeedbackDomain(t) {
  return t.surveyFeedbackDomain;
}

function internalCommunicationDomain(t) {
  return t.internalCommunicationDomain;
}

function systemGenerated(t) {
  return t.systemGenerated;
}

function domainTypeToString(t) {
  var match = t.domainType;
  if (match === "Custom") {
    return "custom";
  } else {
    return "subdomain";
  }
}

function verificationStatusToString(t) {
  var match = t.verificationStatus;
  switch (match) {
    case "NotApplicable" :
        return "not_applicable";
    case "Pending" :
        return "pending";
    case "Verified" :
        return "verified";
    
  }
}

function toggleActive(t) {
  return {
          id: t.id,
          name: t.name,
          domainType: t.domainType,
          verificationStatus: t.verificationStatus,
          active: !t.active,
          deleted: t.deleted,
          defaultDomain: t.defaultDomain,
          surveyFeedbackDomain: t.surveyFeedbackDomain,
          internalCommunicationDomain: t.internalCommunicationDomain,
          systemGenerated: t.systemGenerated
        };
}

function toggleSurveyFeedbackDomain(t) {
  return {
          id: t.id,
          name: t.name,
          domainType: t.domainType,
          verificationStatus: t.verificationStatus,
          active: t.active,
          deleted: t.deleted,
          defaultDomain: t.defaultDomain,
          surveyFeedbackDomain: !t.surveyFeedbackDomain,
          internalCommunicationDomain: t.internalCommunicationDomain,
          systemGenerated: t.systemGenerated
        };
}

function toggleInternalCommunicationdomain(t) {
  return {
          id: t.id,
          name: t.name,
          domainType: t.domainType,
          verificationStatus: t.verificationStatus,
          active: t.active,
          deleted: t.deleted,
          defaultDomain: t.defaultDomain,
          surveyFeedbackDomain: t.surveyFeedbackDomain,
          internalCommunicationDomain: !t.internalCommunicationDomain,
          systemGenerated: t.systemGenerated
        };
}

function toggleDefaultDomain(t) {
  return {
          id: t.id,
          name: t.name,
          domainType: t.domainType,
          verificationStatus: t.verificationStatus,
          active: t.active,
          deleted: t.deleted,
          defaultDomain: !t.defaultDomain,
          surveyFeedbackDomain: t.surveyFeedbackDomain,
          internalCommunicationDomain: t.internalCommunicationDomain,
          systemGenerated: t.systemGenerated
        };
}

function setDomainType(t, domainType) {
  return {
          id: t.id,
          name: t.name,
          domainType: domainType,
          verificationStatus: t.verificationStatus,
          active: t.active,
          deleted: t.deleted,
          defaultDomain: t.defaultDomain,
          surveyFeedbackDomain: t.surveyFeedbackDomain,
          internalCommunicationDomain: t.internalCommunicationDomain,
          systemGenerated: t.systemGenerated
        };
}

function setDomainName(t, name) {
  return {
          id: t.id,
          name: name,
          domainType: t.domainType,
          verificationStatus: t.verificationStatus,
          active: t.active,
          deleted: t.deleted,
          defaultDomain: t.defaultDomain,
          surveyFeedbackDomain: t.surveyFeedbackDomain,
          internalCommunicationDomain: t.internalCommunicationDomain,
          systemGenerated: t.systemGenerated
        };
}

function setVerificationStatus(t, verificationStatus) {
  return {
          id: t.id,
          name: t.name,
          domainType: t.domainType,
          verificationStatus: verificationStatus,
          active: t.active,
          deleted: t.deleted,
          defaultDomain: t.defaultDomain,
          surveyFeedbackDomain: t.surveyFeedbackDomain,
          internalCommunicationDomain: t.internalCommunicationDomain,
          systemGenerated: t.systemGenerated
        };
}

function setActive(t, active) {
  return {
          id: t.id,
          name: t.name,
          domainType: t.domainType,
          verificationStatus: t.verificationStatus,
          active: active,
          deleted: t.deleted,
          defaultDomain: t.defaultDomain,
          surveyFeedbackDomain: t.surveyFeedbackDomain,
          internalCommunicationDomain: t.internalCommunicationDomain,
          systemGenerated: t.systemGenerated
        };
}

function decodeDomainType(json) {
  var match = Json_decode.field("domain_type", Json_decode.string, json);
  switch (match) {
    case "custom" :
        return "Custom";
    default:
      return "Subdomain";
  }
}

function decodeVerificationStatus(json) {
  var match = Json_decode.field("verification_status", Json_decode.string, json);
  switch (match) {
    case "pending" :
        return "Pending";
    case "verified" :
        return "Verified";
    default:
      return "NotApplicable";
  }
}

function decode(json) {
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          domainType: decodeDomainType(json),
          verificationStatus: decodeVerificationStatus(json),
          active: Json_decode.field("active", Json_decode.bool, json),
          deleted: Json_decode.field("deleted", Json_decode.bool, json),
          defaultDomain: Json_decode.field("default_domain", Json_decode.bool, json),
          surveyFeedbackDomain: Json_decode.field("survey_feedback_domain", Json_decode.bool, json),
          internalCommunicationDomain: Json_decode.field("internal_communication_domain", Json_decode.bool, json),
          systemGenerated: Json_decode.field("system_generated", Json_decode.bool, json)
        };
}

function encodeDomainType(domainType) {
  if (domainType === "Custom") {
    return "custom";
  } else {
    return "subdomain";
  }
}

function encodeVerificationStatus(verificationStatus) {
  switch (verificationStatus) {
    case "NotApplicable" :
        return "not_applicable";
    case "Pending" :
        return "pending";
    case "Verified" :
        return "verified";
    
  }
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "name",
                  t.name
                ],
                tl: {
                  hd: [
                    "domain_type",
                    encodeDomainType(t.domainType)
                  ],
                  tl: {
                    hd: [
                      "verification_status",
                      encodeVerificationStatus(t.verificationStatus)
                    ],
                    tl: {
                      hd: [
                        "active",
                        t.active
                      ],
                      tl: {
                        hd: [
                          "deleted",
                          t.deleted
                        ],
                        tl: {
                          hd: [
                            "default_domain",
                            t.defaultDomain
                          ],
                          tl: {
                            hd: [
                              "survey_feedback_domain",
                              t.surveyFeedbackDomain
                            ],
                            tl: {
                              hd: [
                                "internal_communication_domain",
                                t.internalCommunicationDomain
                              ],
                              tl: {
                                hd: [
                                  "system_generated",
                                  t.systemGenerated
                                ],
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            });
}

exports.empty = empty;
exports.id = id;
exports.name = name;
exports.domainType = domainType;
exports.verificationStatus = verificationStatus;
exports.active = active;
exports.deleted = deleted;
exports.defaultDomain = defaultDomain;
exports.surveyFeedbackDomain = surveyFeedbackDomain;
exports.internalCommunicationDomain = internalCommunicationDomain;
exports.systemGenerated = systemGenerated;
exports.domainTypeToString = domainTypeToString;
exports.verificationStatusToString = verificationStatusToString;
exports.toggleActive = toggleActive;
exports.toggleSurveyFeedbackDomain = toggleSurveyFeedbackDomain;
exports.toggleInternalCommunicationdomain = toggleInternalCommunicationdomain;
exports.toggleDefaultDomain = toggleDefaultDomain;
exports.setDomainType = setDomainType;
exports.setDomainName = setDomainName;
exports.setVerificationStatus = setVerificationStatus;
exports.setActive = setActive;
exports.decode = decode;
exports.encode = encode;
/* No side effect */
